import { CommonCivilStatusCrumbs } from './breadcrumb';

export const DocumentRegistryListCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Lista Numeri Registro',
    path: '/stato-civile/registri',
  },
];

export const DocumentRegistryNewCrumbs = [
  ...DocumentRegistryListCrumbs,
  {
    name: 'Nuovo Numero Registro',
    path: '/stato-civile/registri/nuovo',
  },
];

export const DocumentRegistryEditCrumbs = [
  ...DocumentRegistryListCrumbs,
  {
    name: 'Modifica Numero Registro',
    path: '/stato-civile/registri/modifica',
  },
];

export const DocumentRegistryVisualizeCrumbs = [
  ...DocumentRegistryListCrumbs,
  {
    name: 'Visualizza Numero Registro',
    path: '/stato-civile/registri/visualizza',
  },
];
